import React from 'react';
import { t } from 'ttag';
import { Button } from '~/ui/buttons/Button';
import { Flex } from '~/ui/flex/Flex';
import FloppyIcon from '../assets/floppy.svg';
import { OnboardingStages, useOnboardingStore } from '../Store';

export const Autosaving = () => {
  const { stage, next } = useOnboardingStore();
  return (
    <Flex
      variant="list"
      justifyContent="space-between"
      data-test-id="autosaving-card"
    >
      <h2>{t`Autosaving`}</h2>
      <Flex variant="center" w="auto" h="auto">
        <FloppyIcon />
      </Flex>
      <small>
        {t`Your progress is saved automatically. You can quit and come back any time.`}
      </small>
      <Button
        onClick={next}
        disabled={stage !== OnboardingStages.Autosaving}
        aria-hidden={stage !== OnboardingStages.Autosaving}
        data-test-id="next-button"
      >
        {t`Next`}
      </Button>
    </Flex>
  );
};
